// MEO分析の画面（店舗ダッシュボード・比較分析）で共通に使う、数字・日付・配列の小さな関数。

import React from 'react';

// ---- 数字のかたち ---------------------------------------------------------

// webpack 4 は ?? を読めないので、代わりにこれを使う。
export const orElse = (v, fallback) => (v === undefined || v === null ? fallback : v);
export const isNum = (v) => v !== null && v !== undefined && !Number.isNaN(v);
export const fx = (v, d = 1) => (isNum(v) ? (Math.round(v * 10 ** d) / 10 ** d).toFixed(d) : '—');
export const fmtN = (v) => (isNum(v) ? Math.round(v).toLocaleString('ja-JP') : '—');
export const sgn = (v, d = 1) => {
  if (!isNum(v)) return '—';
  const r = Math.round(v * 10 ** d) / 10 ** d;
  return (r > 0 ? '+' : r < 0 ? '−' : '±') + Math.abs(r).toFixed(d);
};

// 順位。21位（圏外として計算した値）以上は「圏外」と出す。
export function rankText(v, outOfRank) {
  if (!isNum(v)) return '—';
  if (v >= outOfRank - 0.05) return '圏外';
  return Number.isInteger(v) ? `${v}位` : `${fx(v)}位`;
}

// 順位の差は「前 − 後」。小さくなる（上がる）のが良いので、正なら緑の▲。
export function DeltaRank({ value }) {
  if (!isNum(value)) return <span className="sd-d-flat">—</span>;
  const r = Math.round(value * 10) / 10;
  if (r > 0) return <span className="sd-d-up">▲{r.toFixed(1)}</span>;
  if (r < 0) return <span className="sd-d-down">▼{Math.abs(r).toFixed(1)}</span>;
  return <span className="sd-d-flat">±0.0</span>;
}

export function DeltaPct({ value, unit = '%' }) {
  if (!isNum(value)) return <span className="sd-d-flat">—</span>;
  const r = Math.round(value * 10) / 10;
  if (r > 0) return <span className="sd-d-up">▲{r.toFixed(1)}{unit}</span>;
  if (r < 0) return <span className="sd-d-down">▼{Math.abs(r).toFixed(1)}{unit}</span>;
  return <span className="sd-d-flat">±0.0{unit}</span>;
}

// ---- 日付 ------------------------------------------------------------------

const WEEKDAYS = '日月火水木金土';

export const parseIso = (s) => {
  const [y, m, d] = s.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d));
};
export const isoOf = (date) => date.toISOString().slice(0, 10);
export const ymd = (s) => s.replace(/-/g, '/');
export const md = (s) => { const d = parseIso(s); return `${d.getUTCMonth() + 1}/${d.getUTCDate()}`; };
export const dayLabel = (s) => `${ymd(s)}（${WEEKDAYS[parseIso(s).getUTCDay()]}）`;

// ---- 配列の集計（null は数えない） -------------------------------------------

export function meanR(arr, a, b) {
  if (!arr) return null;
  let s = 0; let c = 0;
  for (let i = Math.max(a, 0); i <= Math.min(b, arr.length - 1); i += 1) {
    const v = arr[i];
    if (isNum(v)) { s += v; c += 1; }
  }
  return c ? s / c : null;
}

export function countR(arr, a, b) {
  if (!arr) return 0;
  let c = 0;
  for (let i = Math.max(a, 0); i <= Math.min(b, arr.length - 1); i += 1) if (isNum(arr[i])) c += 1;
  return c;
}

export function sumR(arr, a, b) {
  if (!arr) return null;
  let s = 0; let c = 0;
  for (let i = Math.max(a, 0); i <= Math.min(b, arr.length - 1); i += 1) {
    if (isNum(arr[i])) { s += arr[i]; c += 1; }
  }
  return c ? s : null;
}

export function minR(arr, a, b) {
  let m = null;
  for (let i = Math.max(a, 0); i <= Math.min(b, arr.length - 1); i += 1) {
    if (isNum(arr[i]) && (m === null || arr[i] < m)) m = arr[i];
  }
  return m;
}

// 7日移動平均（その日を含む過去7日）。取れていない日は数えない。
export function movingAverage(arr) {
  if (!arr) return arr;
  return arr.map((_, i) => meanR(arr, i - 6, i));
}

export const pct = (before, after) => (isNum(before) && isNum(after) && before ? (after / before - 1) * 100 : null);

export function niceMax(v) {
  if (!(v > 0)) return 1;
  const p = 10 ** Math.floor(Math.log10(v));
  const m = v / p;
  const steps = [1, 1.2, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10];
  return steps.find((s) => m <= s) * p;
}
